import { createSlice } from "@reduxjs/toolkit"
import { SavedAddress } from "types"
import { fetchAddressThunk, fetchInfluencerAddressesThunk } from "./thunk"

export interface AddressBook {
    loading: boolean,
    addressFetching: boolean,
    error: string|null,
    last_fetched_at: number | null,
    list: SavedAddress[],
    items: Record<string, {
        address: SavedAddress,
        last_fetched_at: number | null,
    }>,
    influencers: Record<string, // influencerId
        {
            items: SavedAddress[],
            last_fetched_at: number,
        }   
    >
}

export const initialState: AddressBook = {
    loading: true,
    addressFetching: false,
    error: null,
    last_fetched_at: null,
    list: [],
    items: {},
    influencers: {}
}


const addressBook = createSlice({
    name: 'addressBook',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchAddressThunk.pending, (state) => {
            state.addressFetching = true;
            state.error = null;
        })
        .addCase(fetchAddressThunk.fulfilled, (state, {payload}) => {
            const {address, cache } = payload;
            state.items[address.uuid] = {
                ...(state.items[address.uuid] ?? {}),
                address,
                ...(!cache ? {last_fetched_at: Date.now()} : {})
            }
            state.addressFetching = false;
            state.error = null;
        })
        .addCase(fetchAddressThunk.rejected, (state, {payload}) => {
            state.addressFetching = false;
        })
        .addCase(fetchInfluencerAddressesThunk.fulfilled, (state, {payload}) => {
            const { list, influencerId, last_fetched_at } = payload;
            state.influencers[influencerId] = {
                items: list,
                last_fetched_at: last_fetched_at ?? Date.now() 
            }
        })
    }
})

export default addressBook.reducer